<template>
  <div class="modal" @click.self="setCloseDeal">
    <div class="modal-dialog">
      <div class="modal-title">{{ deal.store_name }} deals <span class="categories-close" @click="setCloseDeal"></span></div>
      <div class="modal-content">
        <div class="code-title" :class="deal && deal.coupons != null ? 'discount' : 'shipping'">
          {{deal.cashback}}
        </div>
        <div class="code-link">
          <img :src="deal.computed_logo" alt="icon" class="code-link-logo"/>
          {{ deal.store_name }}
        </div>
        <div class="code-text" v-if="deal.offer_description">
          {{deal.offer_description}}
        </div>
        <div class="code-date" v-if="this.deal.start_date || this.deal.end_date">
          <div class="code-date-header" >
            <div v-if="this.deal.start_date">
              <span class="code-date-label">From</span>
              <span class="code-date-day">{{getDay(this.deal.start_date)}}</span>
              <span class="code-data-month">{{getMonth(this.deal.start_date)}}</span>
            </div>
            <div v-if="this.deal.end_date">
              <span class="code-date-label">to</span>
              <span class="code-date-day">{{getDay(this.deal.end_date)}}</span>
              <span class="code-data-month">{{getMonth(this.deal.end_date)}}</span>
            </div>
          </div>
          <div class="code-date-footer" v-if="this.deal.end_date && dayDifference > 0">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g opacity="0.75">
              <path d="M1 5.66666H10.3333" stroke="#E2677D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.66675 1L10.3334 5.66667L5.66675 10.3333" stroke="#E2677D" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
            </svg>
            <span>
              {{dayDifference}}
              days left
            </span>
          </div>
        </div>
        <div class="code-copy" v-if="this.deal.coupons">
          <div class="code-copy-label">{{this.deal.coupons}}</div>
          <router-link class="btn-main -large"
                       v-if="showGetDealLink"
                       target="_blank"
                       :to="{
                      name: 'Loader',
                      query: {
                               url: deal.url,
                               title: 'CouponApi',
                               icon: deal.computed_logo,
                               storeImage: deal.storeImage
                             }}"
          >
            Get deal
          </router-link>
          <button class="btn-main -large" @click="copyCode" v-else>Copy code</button>
        </div>
        <div class="code-date-header text-center" v-else>
          <router-link class="btn-main -large w-100"
                       target="_blank"
                       :to="{
                      name: 'Loader',
                      query: {
                               url: deal.url,
                               title: 'CouponApi',
                               icon: deal.computed_logo,
                               storeImage: deal.storeImage
                             }}"
          >
            Get deal
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {POSITION, useToast} from "vue-toastification";

export default {
  props: ['deal', 'storeHost'],
  name: 'GetCode',
  data: function (){
    console.log(this.deal);
    return {
      openDeal: false,
      showGetDealLink: false
    }
  },
  computed: {
    dayDifference () {
      const dealEndDate = this.deal.end_date.split('-')
      const today = new Date()
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(dealEndDate[0], dealEndDate[1] - 1, dealEndDate[2]);
      const secondDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const diffDays = Math.round((firstDate - secondDate) / oneDay);
      return diffDays
    },
    storeLink(){
      return this.storeHost.replace('*.', 'https://')
    }
  },
  mounted(){
    console.log(this.deal);
  },
  methods: {
    setOpenDeal (){
      this.$emit('opendeal')
    },
    setCloseDeal () {
      this.$emit('closedeal')
    },
    copyCode () {
      const el = document.createElement('div')
      el.innerHTML = this.deal.coupons
      document.body.appendChild(el)
      const range = new Range()
      range.selectNode(el)
      const select = window.getSelection()
      select.removeAllRanges()
      select.addRange(range)
      document.execCommand('copy')
      el.remove()
      const toast = useToast()

      toast("Copied!", { position: POSITION.BOTTOM_RIGHT })
      this.showGetDealLink = true
    },
    getDay (date) {
      return date.split('-')[2]
    },
    getMonth (date) {
      switch (date.split('-')[1]){
        case '01':
          return 'Jan'
        case '02':
          return 'Feb'
        case '03':
          return 'Mar'
        case '04':
          return 'Apr'
        case '05':
          return 'May'
        case '06':
          return 'Jun'
        case '07':
          return 'Jul'
        case '08':
          return 'Aug'
        case '09':
          return 'Sep'
        case '10':
          return 'Oct'
        case '11':
          return 'Nov'
        case '12':
          return 'Dec'
      }
    }
  }
}
</script>

<style lang="scss">

/* The Modal (background) */
.modal {
  position: fixed;
  z-index: 10;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;

  &-dialog{
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    width: 90%;
    margin: auto;
    border: 0;
    padding: 0;
    max-width: 500px;
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.4), 0px 0px 0.664039px rgba(0, 0, 0, 0.211221), 0px 1.32808px 0.664039px rgba(0, 0, 0, 0.12), 0px 4px 12px rgba(0, 0, 0, 0.08);
  }

  &-footer {
    padding: 20px;
  }

  &-content {
    padding: 20px;
  }

  &-title {
    font-size: 14px;
    font-weight: 700;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}

.code {
  &-title {
    color: #E2677D;
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 10px;

    &.shipping {
      color: #4b2eff;
    }
  }

  &-text {
    color: #7E7B95;
    font-size: 14px;
    margin-top: 8px;
  }

  &-date {
    background: #F9F9FC;
    border-radius: 4px;
    color: #7E7B95;
    font-size: 13px;
    margin-top: 15px;
    margin-bottom: 25px;
    
    &-header,
    &-footer {
      padding: 10px 15px;
      display: flex;
      justify-content: space-between;
    }
    
    &-footer {
      font-weight: 700;
      text-transform: uppercase;
      color: rgba(226, 103, 125, 0.75);
      box-shadow: inset 0px 1px 0px rgba(196, 187, 250, 0.3);
    }

    &-day {
      font-size: 24px;
      font-weight: 700;
      margin: 0 5px;
    }

    &-month {
      font-size: 16px;
      font-weight: 600;
    }
  }

  &-link {
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 15px;

    img {
      vertical-align: middle;
      margin-right: 8px;
      max-width: 40px;
    }
  }

  &-copy {
    background: #EEEDEA;
    border: 3px dashed #00C6A2;
    border-radius: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 5px 5px 20px;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-transform: uppercase;
    position: relative;

    &:before {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background: #fff;
      border-radius: 100px;
    }

    &:after {
      content: "";
      display: block;
      width: 20px;
      height: 20px;
      position: absolute;
      top: -12px;
      left: 23px;
      background: url("~@/assets/img/scissors.svg") center/contain no-repeat;
    }

    &-label,
    .btn-main {
      position: relative;
    }
  }
}
</style>
